import React  from 'react'
import { FaBars } from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
const Header = () => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };
  return (
    <div>
     
        <nav>
      <div className="menu-icon" onClick={toggleMenu}>
        <FaBars />
       
      </div>

      <Link to={'/'}>  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAAAsCAMAAABorteMAAAAllBMVEX///+3LiqzFg/hs7K0GhPfr6/lwcDaoqG0HhgAVYwAX5EAWo8AUYoATogAXZAAV43U3ud3mrewAAClus0naZf9+Pjy396ZsccAR4S2KST09/lbhqr57+7g6O7s8fVljq/BVVO8y9nJcW+CobzG099OfqUAP4AAOn6twtONqsJBeKHFZGIycJzrzs6oAADXmZi7QD3Of30TAy6FAAADoklEQVRYhe2X/XeaPBTHb926GvJCBCwYlzAGKlBct///n9tNRKsQrX2OPc/ZOX77S7wFPuS+BoC77vosPT9+uajH58/hPkZfLyr69kncrw8XNblz/ymukhrM/8CFJq6X57jTQxpf4urqHUSlPMa6Susz3Oh53guiIVeSwIkrmWXN4faA0OOHy4zNoOMnNr9OuQfzmMuCgKIyaELaHq5LRHDCZXSmeJDpm3Jz1FKZhL452sOFkuQARVnKj3DnP5wWPq7ndh8XbHhTxosPcRdOo7z6CNcqDcm13IXjTr1cXWBeaZQEI6UNn6rLRu+5VVPGes+tqgrkjNJGKru0d1fV0Olv3MXPF8v96TT0c8dtLnOedRBnfIUkQmjI485ydcIIIZjJO65gawjCIAhDXGYW2LJsuPk3bnRk3U4G3HhGg6BJm0ZCHIolaBYI1jFbXABUhG3ZUTLbcRPBobU1l0CKuwYwJCDn/Rw9f7eG76j5KK9kjRuQKNhxcypsMa0EcrGwGrfO9IHbx9dwkWDLILS8EN/ol/VzZDWKb+/nddxz8YfttgrfBjmhVkoVhMZ6wMWXIRqWgo8K+o07fX21G359enr6/TDk1iX6OY5T2HEV6bPbxhfXPMsyLsLZiIsvk2IcuiHWG9/5ZMQ9qiMPV+ROy3joZwAm2oqE8QXu5Nt2blNqu/0zfY9rn21dZyy/FWQ/4cZczMdWsPGgOIrvJNrFd3KEPcdtQtEZMC6vYoIGUK0Qx3lFaWppkgdCLEdYT796ONEZLiRUkISErm90lAYrQVl+tN+a2foF19GYZ3BezV3zvgZT1zdMywkjVcsZbjXHNSOluyoHwTd4Wct3N6TU22Cv5Srskf3KGBdOWRcK+rUp6t2wN+Zg066dQhGOi/cD3P+slWC+gTiavzfm6k2W+OzH3MWPl5eXh9tysZH5Tlun57qTCXgjP5/RtedYhUmi8Q8k5pc9DINLG2cCjVtyU9nNYO2u3tuNd7tXc6sc1Fp2CsuogHqFvYjkKaiNtkWywYxtBFZphg0qb2uMqhGI3GB/LP3Hjmu5cgYqaZELCCoSHBBBGVsTZk3RJLag8SqCFlAdngRWOAriBm2N/7T9GE0vav8dKnG/XbFR9tlQz9CLSWKwOdZrgOUqxOOPnTnYqNq6LPEtGzxDt8vMQJkaH3f7dFmv/dnW4GvXECMXfadTdF6N3w2qtj9jDK5duv8p+1lgCrusodIg0/c+L+666wb6C0dvXjktXNx7AAAAAElFTkSuQmCC" alt="" srcset="" />
      </Link>
      <ul className={`menu ${showMenu ? "active" : ""}`}>
        <li>
          <NavLink to="/" activeClassName="active" exact>
            Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/investments" activeClassName="active">
            Investments
          </NavLink>
        </li>
        <li>
          <NavLink to="/savings" activeClassName="active">
            Savings &amp; Cash
          </NavLink>
        </li>
        <li>
          <NavLink to="/advice" activeClassName="active">
            Advice
          </NavLink>
        </li>
        <li>
          <NavLink to="/tools" activeClassName="active">
            Tools &amp; Calculators
          </NavLink>
        </li>
        <li>
          <NavLink to="/about" activeClassName="active">
            About Us
          </NavLink>
        </li>
      </ul>
    </nav>

    </div>
  )
}

export default Header